import { FC } from "react"

import { getSanitizedHTML } from "../../utils"

interface SafeHTMLRendererProps {
  text: string
  className?: string
}

const SafeHTMLRenderer: FC<SafeHTMLRendererProps> = ({
  text,
  className = ""
}) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: getSanitizedHTML(text) }}
    />
  )
}

export default SafeHTMLRenderer
